
import React, { useEffect, useState } from "react";
import { GetpatientAllergy } from "../../../api/helper";
import { useSelector } from "react-redux";

const DetailsAllergiesPatient = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
const [allergydata, setallergydata] = useState([])
  const profiledata = useSelector((state) => state?.cookies?.userDetails);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

    const Getdata = async () => {
      try {
        const respo = await GetpatientAllergy(profiledata?._id);
        setallergydata(respo?.data?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };
    useEffect(()=>{
      Getdata()
    },[])
  return (
    <div className="patient_right">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          alignSelf: "flex-end",
          marginTop: 20,
          marginRight: 20,
        }}
      >
        <img src={require("../../assest/Images/NKDA_icon.png")} />
        <div className="view_Prescriptions_txt">NKDA</div>
        <div
          className="custom-problem-add-button_two"
          onClick={toggleFormVisibility}
        >
          <img
            src={require("../../assest/Images/plus_icon.png")}
            style={{ marginRight: 10, filter: "invert(1) brightness(5)" }}
          />{" "}
          Add
        </div>
      </div>
 <div className="medication-table-container">
  {allergydata && allergydata.length > 0 ? (
    <table className="medication-table">
      <thead>
        <tr>
          <th>Allergy</th>
          <th>Recorded Date</th>
          <th>Clinical Status</th>
          <th>Verification Status</th>
          <th>Criticality</th>
          <th>Management Measures</th>
        </tr>
      </thead>
      <tbody>
        {allergydata.map((allergy, index) => {
          const formatDate = (dateStr) =>
            new Date(dateStr).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            });

          return (
            <tr key={index}>
              <td>{allergy.Allergy || allergy.sampleAllergyId?.name}</td>
              <td>{formatDate(allergy.Date)}</td>
              <td>{allergy.ClinicalStatus}</td>
              <td>{allergy.VerificationStatus}</td>
              <td>{allergy.Criticality}</td>
              <td>{allergy.ManagementInstructions}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <div className="medication-empty-state">
      <div className="medication-empty-title">Nothing Here Yet</div>
      <div className="medication-empty-description">
        No health records available for this resource
      </div>
    </div>
  )}
</div>

      {isFormVisible && (
        <div className="add_problem_div">
          <div className="Add_problem_txtt">
            Add Allergy
            <img
              src={require("../../assest/Images/crossIconn.png")}
              alt="close"
              onClick={toggleFormVisibility} // Hides form when clicked
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="Record_Details_txtt">Record Details</div>

          {/* Form Inputs */}
          <div className="problem_div_txtt">
            Allergy
            <select className="select_option_style">
              <option></option>
            </select>
          </div>

          <div className="code_txt_div">
            Code
            <input type="number" placeholder="-" className="input_num_style" />
          </div>
          <div className="code_txt_div">
            Clinical Status
            <select className="select_option_style">
              <option>Active </option>
            </select>
          </div>
          <div className="code_txt_div">
            Verification Status
            <select className="select_option_style">
              <option>Unconfirmed </option>
            </select>
          </div>
          <div className="code_txt_div">
            Criticality
            <select className="select_option_style">
              <option>Low </option>
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="care_plan_txtt">Management Instructions</div>
            <div className="code_txt_div">
              <textarea
                placeholder="Add patient instructions                   Optional"
                className="input_num_style"
                style={{ height: "80px", width: "100%" }}
              />
            </div>
          </div>

          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
          >
            <div className="Dosage_Instructions_txtt">Last Reaction</div>
            <div className="optional_txtt">Optional</div>
          </div>
          <div className="code_txt_div">
            Date
            <input type="date" placeholder="-" className="input_num_style" />
          </div>
          <div className="code_txt_div">
            Kind
            <input type="text" className="select_option_style" />
          </div>
          <div className="code_txt_div">
            Severity
            <select className="select_option_style">
              <option>Select</option>
            </select>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* Action Buttons */}
            <div className="action_buttons">
              <button className="cancel_button" onClick={toggleFormVisibility}>
                Cancel
              </button>
              <button className="save_button">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsAllergiesPatient;
